import type { CSSProperties } from "react";
import { Box, Flex, Skeleton, Stack } from "@mantine/core";
import {
  NAV_TABS_FULL_WIDTH_LINE_STYLE,
  navTabsListStyles,
} from "@/shared/styles/navTabsLayout";

/** Placeholder layout while collaboration workspace data loads or refreshes. */
export default function CollaborationWorkspaceSkeleton() {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Flex
        align="center"
        gap="md"
        px="md"
        py="md"
        style={{ borderBottom: "1px solid #E5E7EB", flexShrink: 0 }}
      >
        <Skeleton height={36} width={120} radius="xl" />
        <Skeleton height={24} style={{ flex: 1, maxWidth: 280 }} radius="sm" />
        <Skeleton height={36} width={180} radius="xl" />
      </Flex>

      <Box px="md" pt="md" pb="xl">
        <Skeleton height={88} radius="md" mb="md" />
        <Skeleton height={72} radius="md" mb="md" />

        <Box w="100%" style={NAV_TABS_FULL_WIDTH_LINE_STYLE} mb="md">
          <Flex gap={0} style={navTabsListStyles(3).list as CSSProperties}>
            <Skeleton height={44} style={{ flex: 1 }} radius={0} />
            <Skeleton height={44} style={{ flex: 1 }} radius={0} />
            <Skeleton height={44} style={{ flex: 1 }} radius={0} />
          </Flex>
        </Box>

        <Stack gap="md">
          <Skeleton height={120} radius="md" />
          <Skeleton height={200} radius="md" />
          <Skeleton height={160} radius="md" />
        </Stack>
      </Box>
    </Box>
  );
}
